import Flickity from 'flickity';
/* eslint-disable no-unused-vars */
import fade from 'flickity-fade';
import asNavFor from 'flickity-as-nav-for';

class HeaderCarousel {
  constructor() {
    this._cacheSelectors();
    this._init();
  }

  _cacheSelectors() {
    this._carousel = document.querySelector('.main-carousel');
    this._carouselNav = document.querySelector('.carousel-nav');
  }

  _init() {
    this.flkty = new Flickity(this._carousel, {
      // options
      cellAlign: 'left',
      contain: true,
      pageDots: true,
      prevNextButtons: false,
      fade: true,
    });

    this.flktyNav = new Flickity(this._carouselNav, {
      asNavFor: this._carousel,
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      draggable: false,
    });
  }
}

export default HeaderCarousel;
